import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { Divider, Text } from "@flat-ui";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
/** Style for the font inside the tooltip */
const textStyle = {
  color: "text.primary",
  fontSize: DEFAULT_TEXT_FONT_SIZE
};

/** General padding for the tooltip */
const paddingSize = "8px";

/** Shows a tooltip with the name and description of a team */
export function TeamNameTooltip(t0) {
  const $ = _c(9);
  const {
    team
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingX: paddingSize
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ...textStyle,
      fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT,
      paddingY: paddingSize
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== team.name) {
    t3 = <Text variant="bodyS" component="var" sx={t2}>{team.name}</Text>;
    $[2] = team.name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== team.description) {
    t4 = team.description && <><Divider /><Text variant="bodyS" component="var" sx={{
        ...textStyle,
        paddingY: paddingSize
      }}>{team.description}</Text></>;
    $[4] = team.description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack component="div" sx={t1}>{t3}{t4}</Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}